import request from '@/utils/request'

export function getMenuListApi() {
  return request({
    url: '/auth-service/v1/menu',
    method: 'get'
  })
}

export function getFullMenuListApi() {
  return request({
    url: '/auth-service/v1/full-menu',
    method: 'get'
  })
}

export function getMenuChildApi(query) {
  return request({
    url: '/auth-service/v1/menu-child',
    method: 'get',
    params: query
  })
}

export function getClientIpApi() {
  return request({
    url: '/auth-service/v1/ip',
    method: 'get'
  })
}
